import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {FormGroup} from '@angular/forms';
import {UserCreateRequest, UsersClient,} from '../../../generated-client/generated-api-client';
import {Router} from '@angular/router';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-new.component.html',
  styleUrls: ['./user-new.component.sass'],
})
export class UserNewComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private client: UsersClient,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    this.titleService.setTitle('Felhasználó létrehozása');
  }

  ngOnInit(): void {}

  onSubmit(form: FormGroup): void {
    const request: UserCreateRequest = {
      title: form.get('title')?.value === '' ? null : form.get('title')?.value,
      email: form.get('email')?.value === '' ? null : form.get('email')?.value,
      surname: form.get('surname')?.value === '' ? null : form.get('surname')?.value,
      forename: form.get('forename')?.value === '' ? null : form.get('forename')?.value,
      forename2: form.get('forename2')?.value === '' ? null : form.get('forename2')?.value,
      idNumber: form.get('idNumber')?.value === '' ? null : form.get('idNumber')?.value,
      roles: form.get('roles')?.value === '' ? null : form.get('roles')?.value,
      tenantIds: form.get('tenantIds')?.value === '' ? null : form.get('tenantIds')?.value,
      twoFactorEnabled: form.get('twoFactorEnabled')?.value,
    };
    this.client.create(request).subscribe(
      next => {
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/users']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
